import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import { Container, Alert, Button } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import user1 from "../../assets/images/user.d1a7045e.png"
import maleAvatar from "../../assets/images/users/male-avatar.png"
import femaleAvatar from "../../assets/images/users/female-avatar.png"
import othersAvatar from "../../assets/images/users/others-avatar.png"
import QRCode from "qrcode"
import { editProfile, resetProfileFlag } from "../../store/actions"
import Bg from "../../assets/images/Walmart Converge bg.png"

/* ─── component ─────────────────────────────────────────────── */
const UserProfile = props => {
  const [prof, setprof] = useState(user1)
  const [email, setemail] = useState("")
  const [name, setname] = useState("")
  const [idx, setidx] = useState(1)
  const [qrImageUrl, setQrImageUrl] = useState(null)
  const [badgeType, setBadgeType] = useState("")
  const [ticketVarient, setTicketVarient] = useState("")
  const [qrOpen, setQrOpen] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        setname(
          (obj.Firstname ? obj.Firstname : "") +
            " " +
            (obj.Lastname ? obj.Lastname : "")
        )
        setemail(obj.EmailAddress || obj.Email || "")
        setBadgeType(obj.badgeType || "Coverge 2026")
        setTicketVarient(obj.Ticket_Variant || "Attendee")

        setidx(obj._id)
        if (obj.SelectedAvatar === "maleAvatar") setprof(maleAvatar)
        else if (obj.SelectedAvatar === "femaleAvatar") setprof(femaleAvatar)
        else if (obj.SelectedAvatar === "othersAvatar") setprof(othersAvatar)
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        setname(obj.username)
        setemail(obj.email)
        setidx(obj.uid)
      }
    }
  }, [props.success])

  useEffect(() => {
    const loader = document.querySelector(".loader")
    if (loader) loader.classList.add("loader--hide")

    const obj = JSON.parse(localStorage.getItem("authUser"))
    if (obj?._id) {
      QRCode.toDataURL(obj._id).then(url => setQrImageUrl(url))
    }

    if (obj?.EmailAddress || obj?.Email) {
      fetch(process.env.REACT_APP_ADMIN + "/updateProfile/getprof", {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ Email: obj.EmailAddress || obj.Email }),
      })
        .then(r => r.json())
        .then(data => { if (data.Profile) setprof(data.Profile) })
        .catch(() => {})
    }
  }, [])

  function handleValidSubmit(event, values) {
    props.editProfile(values)
    setTimeout(() => window.location.reload(), 1000)
  }

  return (
    <React.Fragment>
      <div className="prof-page">
        <MetaTags>
          <title>Profile</title>
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        </MetaTags>

        {/* ── Animated background ── */}
        {/* <div className="prof-orb prof-orb-1" />
        <div className="prof-orb prof-orb-2" />
        <div className="prof-orb prof-orb-3" /> */}
        {/* <div className="inv-bg-grid"              aria-hidden="true" /> */}
        {/* <div className="inv-bg-scanlines"         aria-hidden="true" /> */}
        {/* <div className="inv-shoot"                aria-hidden="true">
          <span/><span/><span/><span/><span/>
          <span/><span/><span/><span/>
          <i/><b/><em/>
        </div> */}

        <Container fluid className="prof-container">
          {/* Header */}
        <header className="inv-header">
          <div className="inv-header-line inv-header-line--gold" />
          <h1 className="inv-header-title">
            <span className="inv-header-bracket">[</span>
            PROFILE
            <span className="inv-header-bracket">]</span>
          </h1>
          <div className="inv-header-line inv-header-line--gold" />
        </header>

          {/* Alerts */}
          {props.error && (
            <Alert color="danger" className="prof-alert">{props.error}</Alert>
          )}
          {props.success && (
            <Alert color="success" className="prof-alert">{props.success}</Alert>
          )}

          {/* ── Avatar card ── */}
          <div className="prof-card prof-avatar-card">
            {/* shimmer top bar */}
            <div className="prof-card-bar" />
            <div className="prof-avatar-body">

              {/* Avatar ring */}
              <div className="prof-avatar-ring">
                <img src={prof} alt="avatar" className="prof-avatar-img" />
              </div>

              {/* Name + email */}
              <div className="prof-identity">
                <h5 className="prof-name">{name || "—"}</h5>
                <p className="prof-email">{email || "—"}</p>
              </div>

              {/* QR code — floating tap-me card */}
              {qrImageUrl && (
                <div className="prof-qr-btn" onClick={() => setQrOpen(true)} role="button" aria-label="View QR Code">
                  <div className="prof-qr-glow" />
                  <div className="prof-qr-inner">
                    <img src={qrImageUrl} alt="QR Code" className="prof-qr-thumb" />
                    <div className="prof-qr-pulse-ring" />
                  </div>
                  <span className="prof-qr-cta">Tap to scan</span>
                  {/* <div className="prof-qr-corner prof-qr-corner-tl" />
                  <div className="prof-qr-corner prof-qr-corner-tr" />
                  <div className="prof-qr-corner prof-qr-corner-bl" />
                  <div className="prof-qr-corner prof-qr-corner-br" /> */}
                </div>
              )}

              {/* QR full-screen modal */}
              {qrOpen && (
                <div className="prof-qr-modal-overlay" onClick={() => setQrOpen(false)}>
                  <div className="prof-qr-modal" onClick={e => e.stopPropagation()}>
                    <div className="prof-qr-modal-bar" />
                    <div className="prof-qr-modal-header">
                      {/* <span className="prof-qr-modal-title">Your Event QR</span> */}
                      <button className="prof-qr-modal-close" onClick={() => setQrOpen(false)}>✕</button>
                    </div>
                    <div className="prof-qr-modal-body">
                      <div className="prof-qr-modal-frame">
                                            <div className="prof-qr-pulse-ring" />

                        <img src={qrImageUrl} alt="QR Code" className="prof-qr-modal-img" />
                      </div>
                      {/* <p className="prof-qr-modal-hint">Show this at the event entrance</p> */}
                      {/* <p className="prof-qr-modal-name">{name}</p> */}
                    </div>
                  </div>
                </div>
              )}

              {/* Decorative stats row */}
              {/* <div className="prof-badges">
                <div className="prof-badge">
                  <span className="prof-badge-icon">🎫</span>
                  <span className="prof-badge-text">{ticketVarient}</span>
                </div>
                <div className="prof-badge">
                  <span className="prof-badge-icon">⭐</span>
                  <span className="prof-badge-text">{badgeType}</span>
                </div>
              </div> */}
            </div>
          </div>

          {/* ── Form card ── */}
          <div className="prof-card prof-form-card">
            <div className="prof-card-bar" />
            <div className="prof-form-body">
              <h4 className="prof-section-title">Edit Profile</h4>

              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => handleValidSubmit(e, v)}
              >
                <div className="prof-field">
                  <label className="prof-label">Full Name</label>
                  <AvField
                    name="Name"
                    value={name}
                    className="form-control prof-input"
                    placeholder="Enter Full Name"
                    type="text"
                    required
                  />
                </div>

                <div className="prof-field">
                  <label className="prof-label">Email</label>
                  <AvField
                    name="Email"
                    value={email}
                    className="form-control prof-input prof-input-disabled"
                    placeholder="Email"
                    type="email"
                    disabled
                  />
                  <AvField name="idx" value={idx} type="hidden" />
                </div>

                <button type="submit" className="prof-save-btn">
                  Save Changes
                </button>
              </AvForm>
            </div>
          </div>
        </Container>
      </div>

      {/* ══════════════════════════════════════════════════════════
          ALL STYLES INLINED — same dark navy system as leaderboard
      ══════════════════════════════════════════════════════════ */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@500;600;700&family=DM+Sans:wght@300;400;500&display=swap');

        /* ── PAGE ── */
        .prof-page {
          min-height: 100vh;
          background: url("${Bg}") center center / cover no-repeat;
          position: relative;
          overflow: hidden;
          padding-top: 65px;
          padding-bottom: 50px;
        }

        /* ── ORBS ── */
        .prof-orb {
          position: fixed;
          border-radius: 50%;
          pointer-events: none;
          z-index: 0;
          filter: blur(52px);
          will-change: transform;
        }
        .prof-orb-1 {
          width: 65vw; height: 65vw;
          top: -25vw; left: -18vw;
          background: radial-gradient(circle, rgba(37,99,235,.6) 0%, transparent 65%);
          animation: profOrbA 10s ease-in-out infinite alternate;
        }
        .prof-orb-2 {
          width: 55vw; height: 55vw;
          bottom: -18vw; right: -18vw;
          background: radial-gradient(circle, rgba(0,113,206,.55) 0%, transparent 65%);
          animation: profOrbB 13s ease-in-out infinite alternate;
        }
        .prof-orb-3 {
          width: 40vw; height: 40vw;
          top: 40%; left: 20%;
          background: radial-gradient(circle, rgba(96,165,250,.2) 0%, transparent 65%);
          animation: profOrbC 15s ease-in-out infinite alternate;
        }
        @keyframes profOrbA {
          from { transform: translate(0,0) scale(1); }
          to   { transform: translate(8vw,12vh) scale(1.2); }
        }
        @keyframes profOrbB {
          from { transform: translate(0,0) scale(1); }
          to   { transform: translate(-7vw,-11vh) scale(1.18); }
        }
        @keyframes profOrbC {
          from { transform: translate(0,0) scale(1); opacity:.5; }
          to   { transform: translate(-4vw,8vh) scale(1.3); opacity:1; }
        }

        /* ── SHOOTING STARS ── */
        .prof-shoot {
          position: fixed; top:0; left:0;
          width:100%; height:100%;
          pointer-events:none; z-index:0; overflow:hidden;
        }
        .prof-shoot::before, .prof-shoot::after,
        .prof-shoot span, .prof-shoot i,
        .prof-shoot b, .prof-shoot em, .prof-shoot s {
          position: absolute;
          border-radius: 9999px;
          opacity: 0;
          background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(180,210,255,.4) 30%, rgba(255,255,255,.95) 100%);
        }
        .prof-shoot::before { content:''; top:8%;  left:-5%;  width:130px; height:2px;  animation: profComet 5s linear .5s infinite; }
        .prof-shoot::after  { content:''; top:3%;  left:50%;  width:90px;  height:1.5px;animation: profComet 5s linear 2s  infinite; }
        .prof-shoot span:nth-child(1) { top:22%; left:10%; width:70px;  height:1px;   animation: profCometFaint  6s linear 1s   infinite; }
        .prof-shoot span:nth-child(2) { top:1%;  left:25%; width:110px; height:1.5px; animation: profCometSteep  4.5s linear 3s infinite; }
        .prof-shoot span:nth-child(3) { top:35%; left:-8%; width:160px; height:2px;   background:linear-gradient(90deg,rgba(255,220,100,0) 0%,rgba(255,220,100,.3) 40%,rgba(255,255,200,.9) 100%); animation: profCometShallow 7s linear 0s infinite; }
        .prof-shoot span:nth-child(4) { top:55%; left:5%;  width:85px;  height:1.5px; animation: profComet 5.5s linear 4.5s infinite; }
        .prof-shoot span:nth-child(5) { top:14%; left:70%; width:55px;  height:1px;   animation: profCometFaint  3.5s linear 1.8s infinite; }
        .prof-shoot i  { top:60%; left:-18%; width:180px; height:2.5px; filter:blur(.3px); background:linear-gradient(90deg,rgba(255,200,50,0) 0%,rgba(255,200,50,.2) 30%,rgba(255,230,100,.7) 70%,rgba(255,255,200,.95) 100%); animation:profCometShallow 12s linear 3s infinite; }
        .prof-shoot b  { top:18%; left:60%;  width:50px;  height:1.5px; background:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); animation:profComet 2.8s linear 8s infinite; }
        .prof-shoot em { top:80%; left:-8%;  width:220px; height:2px;   filter:blur(.5px); background:linear-gradient(90deg,rgba(50,130,255,0) 0%,rgba(80,160,255,.3) 30%,rgba(180,210,255,.7) 70%,rgba(255,255,255,.9) 100%); animation:profCometShallow 14s linear 5s infinite; }
        .prof-shoot s  { top:40%; left:15%;  width:80px;  height:1.5px; animation:profComet 4.2s linear 13s infinite; }

        @keyframes profComet {
          0%  { opacity:0; transform:rotate(215deg) translateX(0); }
          4%  { opacity:1; }
          45% { opacity:0; transform:rotate(215deg) translateX(110vw); }
          100%{ opacity:0; transform:rotate(215deg) translateX(110vw); }
        }
        @keyframes profCometFaint {
          0%  { opacity:0; transform:rotate(215deg) translateX(0); }
          4%  { opacity:.5; }
          45% { opacity:0; transform:rotate(215deg) translateX(110vw); }
          100%{ opacity:0; transform:rotate(215deg) translateX(110vw); }
        }
        @keyframes profCometSteep {
          0%  { opacity:0; transform:rotate(235deg) translateX(0); }
          4%  { opacity:.9; }
          45% { opacity:0; transform:rotate(235deg) translateX(110vw); }
          100%{ opacity:0; transform:rotate(235deg) translateX(110vw); }
        }
        @keyframes profCometShallow {
          0%  { opacity:0; transform:rotate(200deg) translateX(0); }
          4%  { opacity:.8; }
          45% { opacity:0; transform:rotate(200deg) translateX(110vw); }
          100%{ opacity:0; transform:rotate(200deg) translateX(110vw); }
        }

        /* ── LAYOUT ── */
        .prof-container {
          position: relative; z-index: 1;
          max-width: 480px !important;
          margin: 0 auto !important;
          padding: 0 12px !important;
        }
        .prof-header { padding: 8px 4px 18px; }
        .prof-title {
          font-family: 'Rajdhani', sans-serif;
          font-size: 2rem;
          font-weight: 700;
          letter-spacing: .1em;
          text-transform: uppercase;
          color: #fff;
          margin: 0;
          position: relative;
        }
        .prof-title::after {
          content: '';
          display: block;
          width: 48px; height: 4px;
          background: linear-gradient(90deg, #2563eb, #60a5fa);
          border-radius: 4px;
          margin-top: 4px;
        }

        /* ── ALERTS ── */
        .prof-alert {
          border-radius: 10px;
          margin-bottom: 12px;
          font-family: 'DM Sans', sans-serif;
        }

        /* ── CARDS ── */
        .prof-card {
          border-radius: 16px;
          overflow: hidden;
          margin-bottom: 18px;
          background: rgba(2,14,54,0.4) !important;
          border: 1px solid rgba(37,99,235,.22) !important;
          box-shadow:
            0 8px 32px rgba(0,0,0,.55),
            0 0 40px rgba(37,99,235,.07),
            inset 0 1px 0 rgba(255,255,255,.06);
          opacity: 0;
          transform: translateY(20px);
          animation: profSlideUp .55s cubic-bezier(.22,1,.36,1) forwards,
                     profCardGlow 4s ease-in-out 1s infinite alternate;
        }
        .prof-avatar-card { animation-delay: .1s, 1s; }
        .prof-form-card   { animation-delay: .22s, 1s; }

        @keyframes profSlideUp {
          to { opacity:1; transform:translateY(0); }
        }
        @keyframes profCardGlow {
          0%   { box-shadow: 0 8px 32px rgba(0,0,0,.55), 0 0 18px rgba(37,99,235,.05), inset 0 1px 0 rgba(255,255,255,.06); }
          100% { box-shadow: 0 8px 40px rgba(0,0,0,.6),  0 0 45px rgba(37,99,235,.16), inset 0 1px 0 rgba(255,255,255,.09); }
        }

        /* shimmer top bar */
        .prof-card-bar {
          height: 4px;
          background: linear-gradient(90deg, #011E60 0%, #2563eb 45%, #60a5fa 75%, #93c5fd 100%);
          background-size: 200% 100%;
          animation: profShimmer 3s linear infinite;
        }
        @keyframes profShimmer {
          0%   { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }

        /* ── AVATAR CARD BODY ── */
        .prof-avatar-body {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 65px 20px 65px;
          gap: 45px;
        }

        /* Avatar ring with rotating gradient border */
        .prof-avatar-ring {
          width: 96px; height: 96px;
          opacity: 0;
          display: none;
          border-radius: 50%;
          padding: 3px;
          background: linear-gradient(135deg, #ffc220, #2563eb, #60a5fa, #ffc220);
          background-size: 300% 300%;
          animation: profRingRotate 4s linear infinite;
          box-shadow: 0 0 22px rgba(37,99,235,.45), 0 0 8px rgba(255,194,32,.3);
        }
        @keyframes profRingRotate {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .prof-avatar-img {
          width: 90px; height: 90px;
          border-radius: 50%;
          object-fit: cover;
          display: block;
          background: #020c2e;
        }

        /* Identity */
        .prof-identity { text-align: center; }
        .prof-name {
          // font-family: 'Rajdhani', sans-serif;
          font-size: 1.4rem;
          font-weight: 700;
          color: #fff;
          margin: 0 0 3px;
          letter-spacing: .04em;
        }
        .prof-email {
          font-size: .82rem;
          color: rgba(255,255,255,.55);
          margin: 0;
        }

        /* QR code */
        /* ── QR FLOATING BUTTON ── */
        .prof-qr-btn {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          padding: 15px 15px 5px;
          border-radius: 18px;
          background: rgba(255,255,255,.04);
          border: 1px solid rgba(255,255,255,.12);
          animation: qrFloat 3s ease-in-out infinite, qrBtnGlow 3s ease-in-out infinite alternate;
          transition: transform .15s, filter .15s;
          -webkit-tap-highlight-color: transparent;
        }
        .prof-qr-btn:active {
          transform: scale(.94) !important;
          filter: brightness(1.3);
        }

        @keyframes qrFloat {
          0%,100% { transform: translateY(0px) scale(1.25); }
          50%      { transform: translateY(-7px) scale(1.3); }
        }
        @keyframes qrBtnGlow {
          0%   { box-shadow: 0 4px 18px rgba(37,99,235,.25), 0 0 0 0 rgba(255,194,32,0); }
          100% { box-shadow: 0 8px 32px rgba(37,99,235,.5),  0 0 0 4px rgba(255,194,32,.12); }
        }

        /* Ambient glow blob behind the card */
        .prof-qr-glow {
          position: absolute;
          inset: -10px;
          border-radius: 24px;
          background: radial-gradient(circle, rgba(37,99,235,.35) 0%, transparent 70%);
          animation: qrGlowPulse 3s ease-in-out infinite alternate;
          pointer-events: none;
          z-index: -1;
        }
        @keyframes qrGlowPulse {
          from { opacity: .5; transform: scale(.95); }
          to   { opacity: 1;  transform: scale(1.05); }
        }

        /* QR image + pulse ring wrapper */
        .prof-qr-inner {
          position: relative;
          width: 80px; height: 80px;
        }
        .prof-qr-thumb {
          width: 80px; height: 80px;
          border-radius: 10px;
          border: 2px solid rgba(255,194,32,.6);
          box-shadow: 0 4px 16px rgba(0,0,0,.5), 0 0 12px rgba(255,194,32,.2);
          display: block;
        }

        /* Expanding pulse ring around the QR */
        .prof-qr-pulse-ring {
          position: absolute;
          inset: -6px;
          border-radius: 14px;
          border: 2px solid rgba(255,194,32,.55);
          animation: qrPulseRing 2s ease-out infinite;
          pointer-events: none;
        }
        @keyframes qrPulseRing {
          0%   { transform: scale(1);    opacity: .8; }
          100% { transform: scale(1.28); opacity: 0; }
        }

        /* "Tap to scan" label */
        .prof-qr-cta {
          font-family: 'Rajdhani', sans-serif;
          font-size: .8rem;
          font-weight: 700;
          letter-spacing: .1em;
          text-transform: uppercase;
          color: #ffc220;
          animation: qrCtaBlink 2s ease-in-out infinite alternate;
        }
        @keyframes qrCtaBlink {
          from { opacity: .7; }
          to   { opacity: 1; }
        }

        /* Corner bracket decorations */
        .prof-qr-corner {
          position: absolute;
          width: 10px; height: 10px;
          border-color: rgba(255,194,32,.7);
          border-style: solid;
        }
        .prof-qr-corner-tl { top: 6px;  left: 6px;  border-width: 2px 0 0 2px; border-radius: 3px 0 0 0; }
        .prof-qr-corner-tr { top: 6px;  right: 6px; border-width: 2px 2px 0 0; border-radius: 0 3px 0 0; }
        .prof-qr-corner-bl { bottom: 6px; left: 6px;  border-width: 0 0 2px 2px; border-radius: 0 0 0 3px; }
        .prof-qr-corner-br { bottom: 6px; right: 6px; border-width: 0 2px 2px 0; border-radius: 0 0 3px 0; }

        /* ── QR MODAL OVERLAY ── */
        .prof-qr-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,.75);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          z-index: 9999;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          animation: overlayFadeIn .25s ease;
        }
        @keyframes overlayFadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }

        /* ── QR MODAL SHEET ── */
        .prof-qr-modal {
          height: 100%;
          width: 100%;
          max-width: 480px;
          background: rgba(2,12,46,.97);
          border: 1px solid rgba(37,99,235,.3);
          border-radius: 15px 15px 0 0;
          overflow: hidden;
          animation: sheetSlideUp .32s cubic-bezier(.22,1,.36,1);
          box-shadow: 0 -8px 40px rgba(37,99,235,.3), 0 -2px 0 rgba(255,194,32,.25);
        }
        @keyframes sheetSlideUp {
          from { transform: translateY(100%); opacity: .5; }
          to   { transform: translateY(0);    opacity: 1; }
        }

        .prof-qr-modal-bar {
          height: 4px;
          background: linear-gradient(90deg, #011E60 0%, #2563eb 45%, #60a5fa 75%, #ffc220 100%);
          background-size: 200% 100%;
          animation: profShimmer 3s linear infinite;
        }

        .prof-qr-modal-header {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 0px;
          position: absolute;
          top: 0;
          width: 100%;
          z-index: 99;
        }
        .prof-qr-modal-title {
          font-family: 'Rajdhani', sans-serif;
          font-size: 1.2rem;
          font-weight: 700;
          letter-spacing: .08em;
          text-transform: uppercase;
          color: #fff;
        }
        .prof-qr-modal-close {
          background: rgba(43,127,255,0.1);
          border: 1px solid rgba(90,173,255,0.25);
          color: #5aadff;
          border-radius: 50%;
          width: 32px; height: 32px;
          font-size: 18px;
          cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          transition: background .2s;
        }
        .prof-qr-modal-close:hover { 
          background: rgba(43,127,255,0.22);
          border: 1px solid rgba(90,173,255,0.5);
          box-shadow: 0 0 14px rgba(43,127,255,0.4);
          }

        .prof-qr-modal-body {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 14px;
          padding: 20px 24px 15px;
        }

        /* White frame around QR for scanner contrast */
        .prof-qr-modal-frame {
          background: #fff;
          border-radius: 16px;
          border: 3px solid rgba(255,194,32,.6);
          width: calc(100% - 0px);
          max-width: 320px;
          box-shadow: 0 0 40px rgba(255,255,255,.1), 0 0 80px rgba(37,99,235,.2);
          animation: modalQrPop .4s cubic-bezier(.34,1.56,.64,1) .1s both;
        }
        @keyframes modalQrPop {
          from { transform: scale(.85); opacity: 0; }
          to   { transform: scale(1);   opacity: 1; }
        }
        .prof-qr-modal-img {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 8px;
        }

        .prof-qr-modal-hint {
          font-size: .82rem;
          color: rgba(255,255,255,.5);
          letter-spacing: .04em;
          text-align: center;
          margin: 0;
        }
        .prof-qr-modal-name {
          font-family: 'Rajdhani', sans-serif;
          font-size: 1.1rem;
          font-weight: 700;
          color: #ffc220;
          letter-spacing: .06em;
          margin: 0;
          text-align: center;
        }

        /* Badges row */
        .prof-badges {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          justify-content: center;
        }
        .prof-badge {
          display: flex;
          align-items: center;
          gap: 6px;
          background: rgba(37,99,235,.18);
          border: 1px solid rgba(37,99,235,.35);
          border-radius: 20px;
          padding: 5px 12px;
          font-size: .78rem;
          color: rgba(255,255,255,.8);
          font-family: 'DM Sans', sans-serif;
          animation: profBadgePop .5s cubic-bezier(.34,1.56,.64,1) forwards;
          opacity: 0;
        }
        .prof-badge:nth-child(1) { animation-delay: .4s; }
        .prof-badge:nth-child(2) { animation-delay: .55s; }
        @keyframes profBadgePop {
          to { opacity:1; }
        }
        .prof-badge-icon { font-size: .9rem; }
        .prof-badge-text { font-weight: 500; }

        /* ── FORM CARD BODY ── */
        .prof-form-body { padding: 20px 18px 22px; }
        .prof-section-title {
          font-family: 'Rajdhani', sans-serif;
          font-size: 1.2rem;
          font-weight: 700;
          letter-spacing: .08em;
          text-transform: uppercase;
          color: #fff;
          margin-bottom: 20px;
          text-align: center;
          position: relative;
        }
        .prof-section-title::after {
          content: '';
          display: block;
          width: 36px; height: 3px;
          background: linear-gradient(90deg, #2563eb, #60a5fa);
          border-radius: 3px;
          margin: 5px auto 0;
        }

        /* Fields */
        .prof-field { margin-bottom: 18px; }
        .prof-label {
          display: block;
          margin-bottom: 7px;
          font-size: .72rem;
          font-weight: 600;
          color: rgba(255,255,255,.5);
          text-transform: uppercase;
          letter-spacing: .08em;
        }

        /* Input — override AvField */
        .prof-input,
        .prof-input.form-control {
          background: rgba(255,255,255,.06) !important;
          border: 1px solid rgba(255,255,255,.14) !important;
          border-radius: 10px !important;
          color: #fff !important;
          font-family: 'DM Sans', sans-serif !important;
          font-size: 15px !important;
          padding: 11px 14px !important;
          width: 100% !important;
          outline: none !important;
          transition: border-color .2s, box-shadow .2s, background .2s;
          -webkit-appearance: none;
          caret-color: #60a5fa;
        }
        .prof-input::placeholder { color: rgba(255,255,255,.3) !important; }
        .prof-input:focus,
        .prof-input.form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37,99,235,.22), 0 0 18px rgba(37,99,235,.12) !important;
          background: rgba(255,255,255,.1) !important;
        }
        .prof-input-disabled,
        .prof-input-disabled.form-control {
          color: rgba(255,255,255,.35) !important;
          cursor: not-allowed !important;
          border-color: rgba(255,255,255,.07) !important;
        }

        /* Save button */
        .prof-save-btn {
          width: 100%;
          padding: 13px;
          border-radius: 12px;
          font-family: 'Rajdhani', sans-serif;
          font-weight: 700;
          font-size: 1.05rem;
          letter-spacing: .08em;
          text-transform: uppercase;
          background: linear-gradient(135deg, #011E60 0%, #0a2d8a 100%);
          border: 1px solid rgba(255,255,255,.1);
          color: #fff;
          margin-top: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          transition: transform .2s, box-shadow .2s, filter .2s;
          box-shadow: 0 4px 20px rgba(1,30,96,.45);
        }
        .prof-save-btn::before {
          content: '';
          position: absolute; inset: 0;
          background: linear-gradient(135deg, rgba(255,255,255,.12) 0%, transparent 60%);
          opacity: 0;
          transition: opacity .2s;
        }
        .prof-save-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 28px rgba(1,30,96,.6);
          filter: brightness(1.15);
        }
        .prof-save-btn:hover::before { opacity: 1; }
        .prof-save-btn:active { transform: scale(.98); }

        /* Validation feedback */
        .invalid-feedback { font-size: 11px; color: #f87171 !important; }

        /* ── MOBILE ── */
        @media (max-width: 576px) {
          .prof-input,
          .prof-input.form-control { font-size: 16px !important; } /* prevent iOS zoom */
          .prof-page { padding-top: 58px; }
        }

        * { box-sizing: border-box; }
      `}</style>
    </React.Fragment>
  )
}

UserProfile.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, { editProfile, resetProfileFlag })(UserProfile)
)